/* Khizra Artstyle - theme.js (speed pass 2026-10-16). Plain, readable code; no libraries. */
(function () {
  var $ = function (id) { return document.getElementById(id); };

  /* Prefetch a page when someone hovers or touches a link, so the next page opens almost instantly.
     Skipped on data saver / 2G, and never for cart, account or checkout pages (those must always be fresh). */
  function startPrefetch() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ""))) return;
    if (!("requestIdleCallback" in window)) window.requestIdleCallback = function (f) { return setTimeout(f, 200); };
    var done = {};
    function prefetch(a) {
      if (!a || !a.href || a.origin !== location.origin || a.target === "_blank") return;
      if (a.pathname === location.pathname && a.search === location.search) return;
      if (/^\/(cart|account|checkouts?)(\/|$)/.test(a.pathname) || done[a.href]) return;
      done[a.href] = true;
      var l = document.createElement("link");
      l.rel = "prefetch";
      l.href = a.href;
      document.head.appendChild(l);
    }
    /* 2026-11-03 (owner: product pages open slowly): a page is fetched only when the mouse RESTS on its link for 80 ms. Before, every link crossed on the way was fetched, and those 80 KB downloads queued ahead of the page that was then clicked. */
    var ht = 0, hl = null;
    document.addEventListener("mouseover", function (e) {
      var a = e.target.closest && e.target.closest("a[href]");
      if (!a || a === hl) return;
      hl = a; clearTimeout(ht);
      ht = setTimeout(function () { prefetch(a); }, 80);
    }, { passive: true });
    document.addEventListener("mouseout", function (e) {
      var a = e.target.closest && e.target.closest("a[href]");
      if (a && a === hl && !(e.relatedTarget && a.contains(e.relatedTarget))) { clearTimeout(ht); hl = null; }
    }, { passive: true });
    document.addEventListener("touchstart", function (e) {
      var a = e.target.closest && e.target.closest("a[href]");
      if (a) prefetch(a);
    }, { passive: true });
  }

  /* Product gallery: thumbnails, arrows, swipe, zoom viewer.
     Each thumbnail carries data-u (the photo's base address). Sizes are built here, so the page HTML stays small.
     Only the photo on screen is downloaded; the next photo is fetched once the customer first touches the gallery. */
  function startGallery() {
    var m = $("galleryMainImg");
    if (!m) return;
    var th = Array.prototype.slice.call(document.querySelectorAll("#galleryThumbs .thumb-pat"));
    var n = th.length || 1, idx = 0, warmed = {};
    var W = [480, 640, 800, 1000, 1200];
    var lb = $("pzLightbox"), li = $("pzImg"), ls = $("pzStage");

    function at(w, i) {
      var b = (th[i] || m).getAttribute("data-u");
      return b + (b.indexOf("?") < 0 ? "?" : "&") + "width=" + w;
    }
    function set(i) {
      return W.map(function (w) { return at(w, i) + " " + w + "w"; }).join(", ");
    }
    /* Slider: every photo sits side by side in one swipeable strip (native scroll-snap, so a swipe follows the finger at once).
       The arrows and thumbnails glide the strip with a short .22s ease. */
    var frame = $("galleryMain"), track = null, slides = [], filled = {}, anim = 0, gt = 0, busy = false, lastIdx = 0;
    var reduce = false; try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
    if (frame && n > 1) {
      track = document.createElement("div");
      track.className = "gal-track";
      m.parentNode.insertBefore(track, m);
      for (var k = 0; k < n; k++) {
        var s = k === 0 ? m : document.createElement("img");
        if (k > 0) {
          s.alt = (th[k].querySelector("img") || {}).alt || "";
          s.setAttribute("width", m.getAttribute("width") || "800"); s.setAttribute("height", m.getAttribute("height") || "1120");
          s.decoding = "async"; s.draggable = false;
        }
        s.classList.add("gal-slide");
        s.setAttribute("draggable", "false");
        track.appendChild(s);
        slides.push(s);
        filled[k] = k === 0;
      }
      m.setAttribute("data-cur", "1");
    }
    function fill(i) {
      i = (i + n) % n;
      if (filled[i] || !slides[i]) return;
      filled[i] = true;
      var s = slides[i];
      try { s.fetchPriority = "low"; } catch (e) {}
      s.sizes = m.sizes;
      s.srcset = set(i);
      s.src = at(800, i);
    }
    function warm(i) { fill(i); }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function glide(i, instant) {
      if (!track) return;
      var to = i * track.clientWidth, from = track.scrollLeft;
      cancelAnimationFrame(anim); clearTimeout(gt);
      if (instant || reduce || Math.abs(to - from) < 2 || Math.abs(i - lastIdx) > 1) {
        busy = false; track.style.scrollSnapType = ""; track.scrollLeft = to; return;
      }
      busy = true;
      track.style.scrollSnapType = "none";
      var t0 = performance.now(), dur = 220;
      function fin() { clearTimeout(gt); cancelAnimationFrame(anim); busy = false; track.style.scrollSnapType = ""; track.scrollLeft = to; }
      clearTimeout(gt); gt = setTimeout(fin, dur + 80);   /* safety: a hidden tab pauses animation frames */
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        track.scrollLeft = from + (to - from) * ease(p);
        if (p < 1) anim = requestAnimationFrame(step); else fin();
      })(t0);
    }
    function mark(i) {
      idx = i;
      if (track) {
        slides.forEach(function (s, k) { if (k === i) s.setAttribute("data-cur", "1"); else s.removeAttribute("data-cur"); });
        fill(i); fill(i + 1); fill(i - 1);
      }
      th.forEach(function (el, k) {
        el.classList.toggle("active", k === i);
        if (k === i && el.scrollIntoView && el.parentNode && el.parentNode.scrollWidth > el.parentNode.clientWidth) {
          try { el.parentNode.scrollTo({ left: el.offsetLeft - (el.parentNode.clientWidth - el.offsetWidth) / 2, behavior: reduce ? "auto" : "smooth" }); } catch (e) {}
        }
      });
    }
    function show(i) {
      var j = (i + n) % n, wrap = Math.abs(j - idx) > 1;
      if (track) {
        lastIdx = idx;
        mark(j);
        glide(j, wrap);
        lastIdx = j;
      } else if (th[j]) {
        m.srcset = set(j);
        m.src = at(800, j);
        var a = th[j].querySelector("img");
        if (a) m.alt = a.alt;
        idx = j;
        th.forEach(function (el, k) { el.classList.toggle("active", k === idx); });
      }
      if (lb && lb.classList.contains("open") && li) {
        li.classList.remove("zoomed");
        setLb(at(1600, idx));
        if (ls) { ls.scrollLeft = 0; ls.scrollTop = 0; }
      }
    }
    if (track) {
      var raf = 0;
      track.addEventListener("scroll", function () {
        if (busy || raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var w = track.clientWidth || 1, k = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w)));
          if (k !== idx) { lastIdx = k; mark(k); }
        });
      }, { passive: true });
      window.addEventListener("resize", function () { track.scrollLeft = idx * track.clientWidth; });
      var go = function () { fill(1); fill(2); fill(n - 1); };
      /* 2026-10-20: after the page loads only the second photo is fetched (so the first swipe is instant); two more (and the last, for the left arrow) follow the moment the visitor touches the gallery, and every move to a photo fetches its neighbours (mark()). Visitors who never swipe no longer download 4 photos they never see. */
      var idle = function () { fill(1); };
      if (document.readyState === "complete") setTimeout(idle, 200); else window.addEventListener("load", function () { setTimeout(idle, 200); });
      ["touchstart", "mouseover", "focusin", "pointerdown"].forEach(function (ev) {
        frame.addEventListener(ev, go, { once: true, passive: true });
      });
    }
    /* zoom viewer: a new photo fades in once it has arrived (the old one never sits there while the new one downloads) */
    function setLb(src) {
      if (!li) return;
      if (li.getAttribute("src") === src) { li.classList.remove("swap"); return; }
      li.classList.add("swap");
      var done = function () { li.classList.remove("swap"); };
      li.onload = done; li.onerror = done;
      li.setAttribute("src", src);
      if (li.complete && li.naturalWidth) done();
    }
    function openLb() {
      if (!lb) return;
      if (li) { li.classList.remove("zoomed"); setLb(at(1600, idx)); }
      if (ls) { ls.scrollLeft = 0; ls.scrollTop = 0; }
      lb.classList.add("open");
      document.body.style.overflow = "hidden";
    }
    function closeLb() {
      if (!lb) return;
      lb.classList.remove("open");
      document.body.style.overflow = "";
      if (li) li.classList.remove("zoomed");
    }

    th.forEach(function (el, k) { el.addEventListener("click", function () { show(k); }); });
    var prev = $("galPrev"), next = $("galNext"), zoom = $("galZoomBtn");
    if (prev) prev.addEventListener("click", function () { show(idx - 1); });
    if (next) next.addEventListener("click", function () { show(idx + 1); });
    if (zoom) zoom.addEventListener("click", openLb);
    if (track) track.addEventListener("click", openLb); else m.addEventListener("click", openLb);
    var pzClose = $("pzClose"), pzPrev = $("pzPrev"), pzNext = $("pzNext");
    if (pzClose) pzClose.addEventListener("click", closeLb);
    if (pzPrev) pzPrev.addEventListener("click", function () { show(idx - 1); });
    if (pzNext) pzNext.addEventListener("click", function () { show(idx + 1); });
    if (li) li.addEventListener("click", function () { li.classList.toggle("zoomed"); });
    document.addEventListener("keydown", function (e) {
      if (!lb || !lb.classList.contains("open")) return;
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowLeft") show(idx - 1);
      if (e.key === "ArrowRight") show(idx + 1);
    });

    var x0 = null, y0 = null;
    function down(e) {
      if (e.touches && e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }
    }
    function up(e) {
      if (x0 === null) return;
      var t = e.changedTouches && e.changedTouches[0];
      if (t) {
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > 1.5 * Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
      }
      x0 = y0 = null;
    }
    if (!track) {
      m.addEventListener("touchstart", down, { passive: true });
      m.addEventListener("touchend", up, { passive: true });
    }
    if (ls) {
      ls.addEventListener("touchstart", down, { passive: true });
      ls.addEventListener("touchend", up, { passive: true });
    }

    var box = document.querySelector(".p-gallery") || m;
    ["touchstart", "mouseover", "focusin"].forEach(function (ev) {
      box.addEventListener(ev, function () { warm(1); }, { once: true, passive: true });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    /* Phone side menu */
    (function () {
      var d = $("drawer");
      if (!d) return;
      var open = $("burgerBtn"), close = $("drawerClose"), veil = $("drawerVeil");
      /* While the menu is open the page behind it must not scroll (html.menu-open, see snippets/site-drawer) */
      function setOpen(on) {
        d.classList.toggle("open", on);
        document.documentElement.classList.toggle("menu-open", on);
      }
      if (open) open.addEventListener("click", function () { setOpen(true); });
      if (close) close.addEventListener("click", function () { setOpen(false); });
      if (veil) veil.addEventListener("click", function () { setOpen(false); });
      d.querySelectorAll("a").forEach(function (a) {
        a.addEventListener("click", function () { setOpen(false); });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && d.classList.contains("open")) setOpen(false);
      });
      window.addEventListener("pageshow", function () { setOpen(false); });
    })();

    /* Search overlay open / close (the search itself lives in snippets/search-overlay.liquid) */
    (function () {
      var ov = $("searchOv");
      if (!ov) return;
      var btn = $("searchBtn"), close = $("searchClose"), veil = $("searchVeil"), input = $("searchInput");
      function shut() { ov.classList.remove("open"); if (btn) btn.focus(); }
      if (btn) btn.addEventListener("click", function () {
        ov.classList.add("open");
        window.setTimeout(function () { if (input) input.focus(); }, 120);
      });
      if (close) close.addEventListener("click", shut);
      if (veil) veil.addEventListener("click", shut);
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && ov.classList.contains("open")) shut();
      });
    })();

    startPrefetch();

    /* Accordions (product page, FAQ) */
    document.querySelectorAll(".acc-head").forEach(function (head) {
      var item = head.parentElement, body = item.querySelector(".acc-body");
      if (!body) return;
      if (item.classList.contains("open")) body.style.maxHeight = body.scrollHeight + "px";
      head.addEventListener("click", function () {
        var wasOpen = item.classList.contains("open");
        item.parentElement.querySelectorAll(".acc-item").forEach(function (it) {
          it.classList.remove("open");
          var b = it.querySelector(".acc-body");
          if (b) b.style.maxHeight = null;
        });
        if (!wasOpen) { item.classList.add("open"); body.style.maxHeight = body.scrollHeight + "px"; }
      });
    });

    startGallery();

    /* Announcement bar rotates between its messages */
    (function () {
      var bar = $("announceBar");
      if (!bar) return;
      var msgs;
      try { msgs = JSON.parse(bar.getAttribute("data-messages") || "[]"); } catch (e) { msgs = []; }
      if (msgs.length < 2) return;
      try { if (matchMedia("(prefers-reduced-motion: reduce)").matches) return; } catch (e) {}
      var i = 0;
      setInterval(function () {
        bar.style.opacity = "0";
        setTimeout(function () { i = (i + 1) % msgs.length; bar.innerHTML = msgs[i]; bar.style.opacity = "1"; }, 400);
      }, 4200);
    })();

    /* Newsletter forms and the home page sign-up popup */
    (function(){var LS_SUB="khizra_nl_subscribed",LS_DISMISS="khizra_nl_dismissed_at",DISMISS_DAYS=7;function isSubscribed(){try{return"1"===localStorage.getItem(LS_SUB)}catch(e){return!1}}function setSubscribed(){try{localStorage.setItem(LS_SUB,"1")}catch(e){}}function recentlyDismissed(){try{var t=localStorage.getItem(LS_DISMISS);return!!t&&Date.now()-parseInt(t,10)<24*DISMISS_DAYS*60*60*1e3}catch(e){return!1}}function setDismissed(){try{localStorage.setItem(LS_DISMISS,String(Date.now()))}catch(e){}}function validEmail(v){return/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)}var iframe=document.getElementById("nlHiddenFrame"),pendingForm=null,pendingTimeout=null;function showMsg(form,text,isError){var msg=form.querySelector(".nl-msg");msg&&(msg.textContent=text,msg.classList.toggle("is-error",!!isError),msg.classList.add("show"))}function markSubscribedUI(form){form.classList.add("nl-done");var row=form.querySelector(".nl-field-row");row&&(row.style.display="none"),showMsg(form,"You're on the list. Welcome to Khizra Artstyle.",!1)}function handleSuccess(){pendingTimeout&&(clearTimeout(pendingTimeout),pendingTimeout=null);if(!pendingForm)return;var f=pendingForm;setSubscribed(),markSubscribedUI(f),"popupNewsletterForm"===f.id&&setTimeout(closePopup,2200),pendingForm=null}iframe&&iframe.addEventListener("load",function(){pendingForm&&handleSuccess()});var nlForms=document.querySelectorAll(".nl-form");nlForms.forEach(function(form){if(isSubscribed())return void markSubscribedUI(form);form.addEventListener("submit",function(ev){var hp=form.querySelector('input[name="nl_hp"]');if(hp&&hp.value)return void ev.preventDefault();var emailInput=form.querySelector('input[type="email"]'),email=emailInput?emailInput.value.trim():"";if(!validEmail(email))return ev.preventDefault(),showMsg(form,"Please enter a valid email address.",!0),void(emailInput&&emailInput.focus());var btn=form.querySelector('button[type="submit"]');btn&&(btn.disabled=!0,btn.dataset.origText=btn.textContent,btn.textContent="Joining…"),showMsg(form,"",!1),pendingForm=form,pendingTimeout&&clearTimeout(pendingTimeout),pendingTimeout=setTimeout(function(){btn&&(btn.disabled=!1,btn.textContent=btn.dataset.origText||btn.textContent),showMsg(form,"Something went wrong. Please try again.",!0),pendingForm=null},9e3)})});var popup=document.getElementById("nlPopup");if(!popup)return;var veil=document.getElementById("nlPopupVeil"),closeBtn=document.getElementById("nlPopupClose"),dismissBtn=document.getElementById("nlPopupDismiss"),panel=popup.querySelector(".nl-popup-panel"),lastFocused=null,shown=!1;function openPopup(){if(shown)return;if(isSubscribed()||recentlyDismissed())return;try{if(window.Shopify&&window.Shopify.designMode)return}catch(e){}shown=!0,lastFocused=document.activeElement,popup.classList.add("open"),popup.setAttribute("aria-hidden","false"),document.body.style.overflow="hidden",setTimeout(function(){var ef=document.getElementById("popupNlEmail");ef&&ef.focus()},350)}function closePopup(){popup.classList.remove("open"),popup.setAttribute("aria-hidden","true"),document.body.style.overflow="",lastFocused&&lastFocused.focus&&lastFocused.focus()}function dismissPopup(){setDismissed(),closePopup()}closeBtn&&closeBtn.addEventListener("click",dismissPopup),dismissBtn&&dismissBtn.addEventListener("click",dismissPopup),veil&&veil.addEventListener("click",dismissPopup),document.addEventListener("keydown",function(e){if("Escape"===e.key&&popup.classList.contains("open")&&dismissPopup(),"Tab"===e.key&&popup.classList.contains("open")&&panel){var focusable=panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');if(focusable.length){var first=focusable[0],last=focusable[focusable.length-1];e.shiftKey&&document.activeElement===first?(e.preventDefault(),last.focus()):e.shiftKey||document.activeElement!==last||(e.preventDefault(),first.focus())}}}),isSubscribed()||recentlyDismissed()||function(){var triggered=!1;function fireOnce(){triggered||(triggered=!0,openPopup())}setTimeout(fireOnce,7000),window.addEventListener("scroll",function onScroll(){var scrolled=window.scrollY||document.documentElement.scrollTop,max=(document.documentElement.scrollHeight||document.body.scrollHeight)-window.innerHeight;max>0&&scrolled/max>.5&&(window.removeEventListener("scroll",onScroll),fireOnce())},{passive:!0}),document.addEventListener("mouseout",function onExit(e){e.relatedTarget||!(e.clientY<=0)||(document.removeEventListener("mouseout",onExit),fireOnce())})}()})();
  });
})();
